export default __webpack_public_path__ + "static/media/admin-icon.975813e5.svg";